'use client'

import SelectInput from '@components/SelectInput'
import { ExplorerContext } from '@context/Explorer/context'
import { Grid, Theme, styled, useTheme } from '@mui/material'
import { ExplorerTraitSummary } from 'types/explorer'
import { useSearchParams } from 'next/navigation'
import { useContext, useMemo } from 'react'

const AttributesSelectSx = (theme: Theme) => ({
  formControl: {
    [theme.breakpoints.down(300)]: {
      width: '50%',
    },
    [theme.breakpoints.between(300, 500)]: {
      width: '70%',
    },
    [theme.breakpoints.between(500, 900)]: {
      width: '45%',
    },
    [theme.breakpoints.between(900, 1300)]: {
      width: '25rem',
    },
    [theme.breakpoints.up(1300)]: {
      width: '20rem',
    },
  },
})

const SelectGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  [theme.breakpoints.between(900, 1300)]: {
    justifyContent: 'center',
  },
}))

function AttributesForm({ traits }: { traits: ExplorerTraitSummary[] }) {
  const params = useSearchParams()
  const { selectTraitHandler } = useContext(ExplorerContext)
  const theme = useTheme()

  // Trait types come from the static manifest, via the server layout.
  const attributes = useMemo(
    () =>
      traits.map(({ traitType }) => ({ value: traitType, name: traitType })),
    [traits],
  )

  return (
    <SelectGrid item xs>
      <SelectInput
        sx={AttributesSelectSx(theme)}
        noLabel
        noEmptyValue
        initialValue={params.get('trait') || attributes[0]?.value}
        onChange={selectTraitHandler}
        items={attributes}
      />
    </SelectGrid>
  )
}

export default AttributesForm
